import { Pipe, PipeTransform } from '@angular/core';

interface extendedFilteredObject {
    first_name?: string,
    last_name?: string,
    name?: string,
    email?: string,
    username?: string,
}

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe<T extends extendedFilteredObject> implements PipeTransform {
    transform(items: T[], searchText: string): T[] {

        if (!items) {
            return [];
        }

        if (!searchText) {
            return items;
        }

        searchText = searchText.toLowerCase();
        return items.filter((it: T) => {
            let fullname;
            if (it.first_name && it.last_name) {
                fullname = it.first_name + ' ' + it.last_name;
            }

            if (it.name && it.email) {
                return it.name.toLowerCase().includes(searchText) ||
                    it.email.toLowerCase().includes(searchText);
            } else if (it.name && !it.email) {
                return it.name.toLowerCase().includes(searchText);
            } else if (fullname && it.email) {
                return it.first_name.toLowerCase().includes(searchText) ||
                    it.last_name.toLowerCase().includes(searchText) ||
                    it.email.toLowerCase().includes(searchText);
            } else if (it.username && it.email) {
                return it.username.toLowerCase().includes(searchText) ||
                    it.email.toLowerCase().includes(searchText);
            }
        });
    }
}
